(function () {
  'use strict';

  var SIZES = [
    { name: 'S',   hMin: 155, hMax: 169, wMin: 45,  wMax: 68,  A: 67.6, B: 46.4, C: 41.3 },
    { name: 'M',   hMin: 165, hMax: 176, wMin: 60,  wMax: 80,  A: 71,   B: 51.4, C: 45   },
    { name: 'L',   hMin: 172, hMax: 183, wMin: 72,  wMax: 92,  A: 74.6, B: 56,   C: 48.3 },
    { name: 'XL',  hMin: 178, hMax: 191, wMin: 85,  wMax: 105, A: 78,   B: 61,   C: 52   },
    { name: '2XL', hMin: 185, hMax: 211, wMin: 95,  wMax: 140, A: 80.3, B: 66,   C: 55.2 }
  ];

  var FIT_OFFSET = { slim: -1, regular: 0, loose: 1 };
  var FIT_LABEL  = { slim: 'Slim', regular: 'Regular', loose: 'Loose' };
  var state = { fit: null, step: 0 };

  var modal    = document.getElementById('cultefc-modal');
  var openBtn  = document.getElementById('cultefc-open-sf');
  var closeBtn = document.getElementById('cultefc-close');
  var screens  = document.querySelectorAll('.cultefc-screen');
  var segs     = [
    document.getElementById('cseg0'),
    document.getElementById('cseg1'),
    document.getElementById('cseg2')
  ];

function openModal() {
    document.body.appendChild(modal);
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  openBtn  && openBtn.addEventListener('click', openModal);
  closeBtn && closeBtn.addEventListener('click', closeModal);

  modal && modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  var modalBox = document.querySelector('.cultefc-modal-box');
  modalBox && modalBox.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  function goTo(n) {
    state.step = n;
    screens.forEach(function (s, i) {
      s.classList.toggle('cultefc-hidden', i !== n);
    });
    segs.forEach(function (seg, i) {
      seg.classList.toggle('active', i <= n);
    });
  }

  var cbtn0 = document.getElementById('cbtn0');
  cbtn0 && cbtn0.addEventListener('click', function () { goTo(1); });

  var cbtn1 = document.getElementById('cbtn1');
  cbtn1 && cbtn1.addEventListener('click', function () {
    computeResult();
    goTo(2);
  });

  var cbtn1back = document.getElementById('cbtn1back');
  cbtn1back && cbtn1back.addEventListener('click', function () { goTo(0); });

  var cbtn2back = document.getElementById('cbtn2back');
  cbtn2back && cbtn2back.addEventListener('click', function () {
    resetAll();
    goTo(0);
  });

  var fitCards = document.querySelectorAll('.cultefc-fit-card');
  fitCards.forEach(function (card) {
    card.addEventListener('click', function () {
      state.fit = card.dataset.fit;
      fitCards.forEach(function (c) { c.classList.remove('selected'); });
      card.classList.add('selected');
      if (cbtn0) cbtn0.disabled = false;
    });
  });

  var hSlider  = document.getElementById('cHeight');
  var wSlider  = document.getElementById('cWeight');
  var hDisplay = document.getElementById('chv');
  var wDisplay = document.getElementById('cwv');

  hSlider && hSlider.addEventListener('input', function () {
    hDisplay.textContent = hSlider.value;
  });
  wSlider && wSlider.addEventListener('input', function () {
    wDisplay.textContent = wSlider.value;
  });

  function computeResult() {
    var h = parseInt(hSlider.value);
    var w = parseInt(wSlider.value);
    var best = 0, bestScore = 99999;
    SIZES.forEach(function (sz, i) {
      var mh = (sz.hMin + sz.hMax) / 2;
      var mw = (sz.wMin + sz.wMax) / 2;
      var score = Math.abs(h - mh) / 30 + Math.abs(w - mw) / 20;
      if (score < bestScore) { bestScore = score; best = i; }
    });

    var offset = FIT_OFFSET[state.fit] || 0;
    var idx = Math.max(0, Math.min(SIZES.length - 1, best + offset));
    var sz = SIZES[idx];

    document.getElementById('cResultSize').textContent = sz.name;
    document.getElementById('cResultFit').textContent  = FIT_LABEL[state.fit];
    document.getElementById('cDimA').textContent = sz.A + ' cm';
    document.getElementById('cDimB').textContent = sz.B + ' cm';
    document.getElementById('cDimC').textContent = sz.C + ' cm';
    document.getElementById('cCartSize').textContent = sz.name;
    document.getElementById('cCartBtn').dataset.size = sz.name;

    var badgeEl = document.getElementById('cResultBadge');
    if (idx === best)        badgeEl.textContent = 'Taille idéale';
    else if (offset > 0)     badgeEl.textContent = 'Taille au-dessus';
    else                     badgeEl.textContent = 'Taille en-dessous';

    var hint = '';
    if (idx === 0 && best > 0)         hint = 'Tu es en S — si tu veux plus d\'aisance, passe en M.';
    else if (idx === SIZES.length - 1) hint = 'Tu es en 2XL, la taille maximale de notre grille.';
    else if (offset > 0)               hint = 'Recommandation ajustée pour un fit ample.';
    else if (offset < 0)               hint = 'Recommandation ajustée pour un fit près du corps.';
    else                               hint = 'En cas de doute entre deux tailles, prends la plus grande.';
    document.getElementById('cHint').textContent = hint;
  }

  var cartBtn = document.getElementById('cCartBtn');
 cartBtn && cartBtn.addEventListener('click', function () {
    var recommendedSize = cartBtn.dataset.size;
    var variantId = null;

document.querySelectorAll('fieldset input[type="radio"]').forEach(function (btn) {
      var label = btn.closest('label') || document.querySelector('label[for="' + btn.id + '"]');
      var labelText = label ? label.textContent.trim().toUpperCase() : btn.value.trim().toUpperCase();
      if (labelText === recommendedSize.toUpperCase()) {
        variantId = btn.dataset.optionValueId || btn.dataset.variantId || btn.value;
      }
    });

    if (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function() {
        closeModal();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    }
  });

  function resetAll() {
    state.fit  = null;
    state.step = 0;
    fitCards.forEach(function (c) { c.classList.remove('selected'); });
    if (cbtn0)    cbtn0.disabled = true;
    if (hSlider)  hSlider.value  = 175;
    if (wSlider)  wSlider.value  = 75;
    if (hDisplay) hDisplay.textContent = 175;
    if (wDisplay) wDisplay.textContent = 75;
  }

})();